import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useTrainings } from 'modules/trainings/hooks/Trainings/useTrainings'
import { UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

interface TrainingsProps {
  readonly: boolean
  form: FormikProps<UpdateData>
}

export const TrainingsBlock = ({ form, readonly }: TrainingsProps) => {
  const { trainings } = useTrainings({ catalog: true })
  if (!trainings)
    return (
      <Box gap="s8">
        <Text size="200" color="grey1000" weight="medium">
          {i18n.t('trainings.training_requests.create.training')}
        </Text>
        <Skeleton width="full" height="s40" />
      </Box>
    )

  return (
    <Selector.Popover
      label={i18n.t('trainings.training_requests.create.training_name')}
      placeholder={i18n.t('trainings.training_requests.create.select_placeholder')}
      searchPlaceholder={i18n.t('common.search')}
      blankLabel=""
      value={[form.values.trainingId]}
      onChange={(selection) => form.setValues({ ...form.values, trainingId: Number(selection) })}
      isDisabled={readonly}
      error={form.errors.trainingId}
      mandatory
    >
      {trainings.map((training) => {
        return (
          <Selector.Option
            key={training.id}
            value={training.id}
            label={training.name}
            searchValue={training.name}
          >
            {training.name}
          </Selector.Option>
        )
      })}
    </Selector.Popover>
  )
}
